import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Award, CheckCircle, Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="footer-main">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Logo and Description */}
          <div className="footer-section">
            <img 
              src="https://customer-assets.emergentagent.com/job_trustygas/artifacts/191wqlf3_file_000000004ca871f48b719ce9d2a32667.png" 
              alt="The Gas Guide UK"
              className="footer-logo"
            />
            <p className="footer-description">
              Your trusted directory of vetted, Gas Safe registered engineers across the UK.
            </p>
            <div className="footer-badges">
              <div className="footer-badge">
                <Shield size={20} />
                <span>Verified Engineers</span>
              </div>
              <div className="footer-badge">
                <Award size={20} />
                <span>Quality Assured</span>
              </div>
            </div>
            <div className="footer-social" data-testid="footer-social-links">
              <a href="https://www.facebook.com/profile.php?id=61587962796037" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="footer-social-link">
                <Facebook size={20} />
              </a>
              <a href="https://www.instagram.com/thegasguide.co.uk/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="footer-social-link">
                <Instagram size={20} />
              </a>
              <a href="https://www.linkedin.com/in/the-gas-guide-a637ba3b7" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="footer-social-link">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/find-engineer">Find an Engineer</Link></li>
              <li><Link to="/for-engineers">For Engineers</Link></li>
              <li><Link to="/standards">Our Standards</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/partners">Partners &amp; Sponsors</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div className="footer-section">
            <h3 className="footer-heading">Support</h3>
            <ul className="footer-links">
              <li><Link to="/contact">Contact Us</Link></li>
              <li><a href="https://www.gassaferegister.co.uk" target="_blank" rel="noopener noreferrer">Gas Safe Register</a></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
            </ul>
          </div>

          {/* Trust Info */}
          <div className="footer-section">
            <h3 className="footer-heading">Our Promise</h3>
            <ul className="footer-trust-list">
              <li><CheckCircle size={16} /> All engineers Gas Safe registered</li>
              <li><CheckCircle size={16} /> Comprehensive vetting process</li>
              <li><CheckCircle size={16} /> Free for engineers — no subscriptions</li>
              <li><CheckCircle size={16} /> No shared leads or bidding</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} The Gas Guide UK. All rights reserved.</p>
          <p className="footer-disclaimer">
            Always check Gas Safe registration at <a href="https://www.gassaferegister.co.uk" target="_blank" rel="noopener noreferrer">gassaferegister.co.uk</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
